import React, { memo } from 'react';
import classNames from 'classnames';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';

const DESTRUCTIVE_MESSAGE = /\b(delet|remov)/i;

const ConfirmPopup = props => {
  const {
    onOk,
    onCancel,
    header = 'Confirm Action',
    waiting = false,
    message = '',
    submessage = '',
    yes = 'OK',
    no = 'Cancel',
    danger,
  } = props;
  const isDanger = danger ?? (typeof message === 'string' && DESTRUCTIVE_MESSAGE.test(message));
  const footer = (
    <>
      <Button
        key="ok"
        className={classNames('btn-sm', isDanger ? 'btn-danger' : 'btn-primary')}
        data-dismiss="modal"
        loading={waiting}
        onClick={onOk}
        autoFocus
      >
        {yes}
      </Button>
      <Button key="close" className="btn-default btn-sm" data-dismiss="modal" onClick={onCancel}>
        {no}
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="LPRole">
      {message}
      <p className="mb0 font-size-11">{submessage}</p>
    </Popup>
  );
};

export default memo(ConfirmPopup);
